import { gateway } from "src/gateway";

interface GetInvoiceByExternalUidParams {
  externalUid: string;
}

export const getInvoiceByExternalUid = async ({
  externalUid,
}: GetInvoiceByExternalUidParams): Promise<any> => {
  const { data } = await gateway.get("/invoices", {
    params: {
      externalUid,
    },
  });

  return data;
};
